import React, { AriaAttributes } from 'react'
import { SortingDirection, SortingField, WtnColorsEnum } from 'types/global'
import styles from './styles/table-header-with-arrow.module.scss'
import cx from 'classnames'
import { ClassNamesProps } from 'types/utilities'

const getAriaSortValue = (dir?: SortingDirection): AriaAttributes['aria-sort'] => {
  switch (dir) {
    case SortingDirection.ASC:
      return 'ascending'
    case SortingDirection.DESC:
      return 'descending'
    default:
      return 'none'
  }
}

const SortIcon = ({ isActive, direction }: { isActive: boolean; direction?: SortingDirection }) => {
  const color = isActive ? WtnColorsEnum.SECONDARY_ALT : WtnColorsEnum.TERTIARY

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      fill='none'
      viewBox='0 0 22 22'
      transform={isActive && direction === SortingDirection.DESC ? 'rotate(180)' : undefined}
      aria-hidden
    >
      <path
        fill={color}
        d='M11.915 13.37V5.5h-1.829v7.87l-2.742-2.75-1.293 1.296 4.303 4.315c.172.172.404.269.647.269.242 0 .475-.097.646-.269l4.304-4.315-1.293-1.296-2.743 2.75z'
        opacity={isActive ? '1' : '.6'}
      />
    </svg>
  )
}

type ClassKeys = 'cell' | 'button' | 'label'

interface Props extends ClassNamesProps<ClassKeys> {
  label: string
  isActive: boolean
  direction?: SortingDirection
  onClick: (sortingField: SortingField) => any
  fieldToUpdate: SortingField
}

const TableHeaderWithArrow = ({
  label,
  isActive,
  direction,
  onClick,
  fieldToUpdate,
  classNames,
}: Props) => {
  return (
    <th
      className={cx(styles.tableHeaderWithArrow, classNames?.cell)}
      scope='col'
      aria-sort={isActive ? getAriaSortValue(direction) : 'none'}
    >
      <button
        onClick={() => onClick(fieldToUpdate)}
        className={cx(styles.button, classNames?.button)}
      >
        <span className={cx(styles.label, classNames?.label)}>{label}</span>
        <SortIcon isActive={isActive} direction={direction} />
      </button>
    </th>
  )
}

export default TableHeaderWithArrow
